export default {"src":"/_next/static/media/arrowBack.29bb419e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};